<i18n src="./resources/locales.json"></i18n>
<template>
  <SmsContactSelectDialog
    ref="contactSelectionForShareDialog"
    @select-contact="openConversationOfSelectedContacts"
    @cancel-contact-selection="cancelContactSharing"
  />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Contact from '@/classes/v2/Contact';
import SmsContactSelectDialog from '@/components/SmsContactSelectDialog/SmsContactSelectDialog';

export default {
  name: 'SmsContactSharing',

  components: { SmsContactSelectDialog },

  data() {
    return {
      contactsToShare: []
    };
  },

  computed: {
    ...mapGetters('conversationsV2', ['getConversationById'])
  },

  mounted() {
    this.$root.$on('share-contacts', this.openSelectContactsDialog);
    this.$root.$on('select-contacts-to-share', this.openSelectContactsToShareDialog);
  },

  beforeDestroy() {
    this.$root.$off('share-contacts');
    this.$root.$off('select-contacts-to-share');
  },

  methods: {
    ...mapActions('conversationsV2', ['setActiveConversationId']),

    /**
     * Open the select contact dialog when the share contact is emitted.
     */
    openSelectContactsDialog(contacts) {
      this.contactsToShare = contacts;
      this.$refs.contactSelectionForShareDialog.open();
    },

    openSelectContactsToShareDialog() {
      this.$refs.contactSelectionForShareDialog.open();
    },

    _getVcfCard(contacts) {
      const vcfCardWithContacts = Contact.getVcfCardFromContacts(contacts);
      const vcfCardName = vcfCardWithContacts.numberOfContacts > 1
        ? `${this.$t('vCardNameForGroup', {
            firstContactName: vcfCardWithContacts.name,
            restOfContactsLength: vcfCardWithContacts.numberOfContacts - 1
          })}.vcf`
        : `${vcfCardWithContacts.name}.vcf`;

      return {
        name: vcfCardName,
        type: vcfCardWithContacts.type,
        content: vcfCardWithContacts,
        src: vcfCardWithContacts.file
      };
    },

    async _shareSelectedContactsToConversation(selectedContacts) {
      if (!selectedContacts.length) return;

      this.$root.$emit('add-file-to-conversation-footer', this._getVcfCard(selectedContacts));
      await this.$nextTick();
      this.$root.$emit('focus-conversation-input');
    },

    async _shareContactsToSelectedContacts(selectedContacts) {
      if (!selectedContacts.length) return;

      if (selectedContacts.length === 1) {
        const conversation = this.getConversationById(selectedContacts[0].number);
        if (conversation) {
          this.setActiveConversationId(conversation.conversationId);
        }
      } else {
        this.setActiveConversationId(null);
        this.$root.$emit('clear-contact-selection');
        await this.$nextTick();
        selectedContacts.forEach(contact => {
          this.$root.$emit('add-contact-to-contact-selection', contact);
        });
      }

      this.$root.$emit('close-sidebar');
      await this.$nextTick();
      this.$root.$emit('add-file-to-conversation-footer', this._getVcfCard(this.contactsToShare));
      await this.$nextTick();
      this.$root.$emit('focus-conversation-input');
      this.contactsToShare = [];
    },

    /**
     * Share the contactsToShare to a selected contact.
     * It opens first the selected contact conversation and the place the contact to share in conversation footer.
     * @param {Array<Object>} - selectedContacts. The selected contact that will be sent the contact to share.
     */
    openConversationOfSelectedContacts(selectedContacts) {
      if (Array.isArray(this.contactsToShare) && this.contactsToShare.length) {
        this._shareContactsToSelectedContacts(selectedContacts);
      } else {
        this._shareSelectedContactsToConversation(selectedContacts);
      }
    },

    /**
     * Cancels the contact sharing.
     */
    cancelContactSharing() {
      this.contactsToShare = [];
    }
  }
};
</script>
